import type { SentryLogOptions } from './types';

export const createTags = ({ loggerId, sessionId, userId, brand }: SentryLogOptions) => {
  const tags: Record<string, string> = {};

  if (loggerId) tags.logger = loggerId;
  if (sessionId) tags.sessionId = sessionId;
  if (userId) tags.userId = userId;
  if (brand) tags.brand = brand;

  return tags;
};
